import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale';
import zh_CN from './zh_CN'
import en from './en'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import { getStore, keys } from '../store'

Vue.use(VueI18n)

const messages = {
    en: Object.assign(en, enLocale),
    zh_CN: Object.assign(zh_CN, zhLocale)
}

const i18n = new VueI18n({
    locale: 'zh_CN',//getStore(keys.lang) || 'en'
    messages
})


locale.i18n((key, value) => i18n.t(key, value))

export default i18n


// WEBPACK FOOTER //
// ./src/locales/i18n.js